












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { QRcodeLayer } from "@/model/document2/page/surface/design/layer/qrcodeLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class QRcodeMarginController extends Vue 
{
    @Prop() layer! : QRcodeLayer;

    private static readonly MARGIN_ON = "表示する";
    private static readonly MARGIN_OFF = "表示しない";

    private get marginText()
    {
        return this.layer.margin ? QRcodeMarginController.MARGIN_ON : QRcodeMarginController.MARGIN_OFF;
    }

    private changeMargin()
    {
        this.changeLayerProperty("margin", !this.layer.margin, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
